import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useConvertToAgreement = (applicationId) => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "convertToAgreement"
  );
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [applicationId]);
  // options: { fixedRate?: boolean } - omitted means the backend default
  const convertToAgreement = async (options = {}) => {
    try {
      const result = await executeCallable({ applicationId, ...options });
      if (result?.data?.success) {
        setComplete(true);
        return true;
      } else {
        setComplete(false);
        return false;
      }
    } catch (err) {
      setComplete(false);
      return false;
    }
  };
  return {
    saving,
    error,
    success: !saving && !error && complete,
    convertToAgreement,
  };
};
